define(function(require) {

    var ReCaptcha = require('modules/google-recaptcha/recaptcha');
    var core = require('core');
    var _ = require('underscore');

    let recaptchaList = [];

    const getRecaptcha = input => recaptchaList.find(i => i.input === input);

    const createContainer = (input) => {
        const field = input.closest('[data-validation-type]');
        const div = document.createElement('div');
        const id = _.uniqueId('recaptcha_');

        div.id = id;
        div.className = 'fn-field-recaptcha google-recaptcha-validation';
        field.parentNode.insertBefore(div, field.nextSibling);

        return [div, `#${id}`];
    };

    const updateRecaptcha = (item, { onValidate, onError }) => {
        onValidate && item.onValidates.push(onValidate);
        onError && item.onErrors.push(onError);
    };

    const createRecaptcha = (input, { operation, onValidate, onError }) => {
        const [container, selector] = createContainer(input);
        const instance = new ReCaptcha({ selector, operation });

        const item = {
            input,
            onValidates: [onValidate],
            onErrors: [onError],
            instance,
            container,
            clear: () => {
                instance.remove();
                container.remove();
                recaptchaList = recaptchaList.filter(i => i.input !== input);
                core.trigger('recaptcha:hide', { input });
            }
        };

        recaptchaList = [...recaptchaList, item];

        return item;
    };

    const showRecaptcha = (input, { operation, onValidate, onError }) => {
        const item = getRecaptcha(input);

        if (item) {
            updateRecaptcha(item, { onValidate, onError });
            return { isUpdated: true };
        }

        const {
            instance,
            onValidates,
            onErrors,
            clear
        } = createRecaptcha(input, { operation, onValidate, onError });

        instance.render({
            onValidate: ({ token }) => {
                onValidates.forEach(fn => fn(token));
                clear();
            },
            onError: ({ translated: message, isScriptLoadingError }) => {
                onErrors.forEach(fn => fn({ message }));

                if (isScriptLoadingError) {
                    clear();
                }
            }
        });

        return { isCreated: true };
    };

    return {
        showRecaptcha
    };
});
